import { Injectable } from "@angular/core";
import { FluxoToleranciaService } from "./fluxo-tolerancia.service";
import { IdentificadorProcessoService } from "./identificador-processo.service";
import { HttpClient } from "@angular/common/http";
import { EnvService } from "./env.service";

// Utilizar este serviço para fazer inicializações

@Injectable({ providedIn: "root" })
export class AppInitService {
  constructor(
    private idFluxoSrv: IdentificadorProcessoService,
    private fluxoTolSrv: FluxoToleranciaService,
    private _http: HttpClient
  ) {

  }

  private _getVersao(): Promise<void> {
    return new Promise<void>((resolve, reject) => {

      this._http.get("assets/version.txt", { responseType: "text" })
        .toPromise()
        .then((response) => {
          // Builds de tag (ex. V.1.40M.3_...) ou de branch de release (ex. release/1.40M_...)
          // mantêm o sufixo da release específica de cliente
          const tag = /(?:V\.|release\/)(\d+)\.(\d+)([A-Z]?)(?!\d)/.exec(response);
          if (tag) {
            EnvService.version = `V.${tag[1]}.${tag[2]}${tag[3]}`;
          } else {
            const regex = /(?:\D*?)(\d)(?:\D*?)(\d)(?:\D*?)(\d)/g;
            const matches = regex.exec(response);
            if (matches) {
              EnvService.version = `V.${matches[1]}.${matches[2]}${matches[3]}`;
            }
          }

          resolve();
        })
        .catch((error) => {
          // Se n achou o version.txt significa que está no localhost
          // e nesse caso n tem problema pois esse tratamento foi feito exclusivamente para o ambiente de suporte
          resolve();
        });
    })

  }

  public init(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      await this._getVersao();
      this.idFluxoSrv.init();
      this.fluxoTolSrv.init();
      resolve();
    });
  }
}
